import ChronicHungerIndicator from './ChronicHungerIndicator';

export default ChronicHungerIndicator;
